module.exports = __webpack_public_path__ + "static/img/UTSC老师_文娜.71e8634.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSC/UTSC老师_文娜.png
// module id = xz9A
// module chunks = 0